export default "__VITE_ASSET__BbOBqmmj__"